(function (scope) {
  function initialize(root) {
    const categoryButtons = Array.from(root.querySelectorAll('[data-fizo-faq-category]'));
    const panels = Array.from(root.querySelectorAll('[data-fizo-faq-panel]'));

    if (categoryButtons.length === 0 || panels.length === 0) return;

    function activate(categoryKey) {
      categoryButtons.forEach((button) => {
        const active = button.dataset.fizoFaqCategory === categoryKey;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
        button.setAttribute('tabindex', active ? '0' : '-1');
      });

      panels.forEach((panel) => {
        const active = panel.dataset.fizoFaqPanel === categoryKey;
        panel.hidden = !active;
        const questions = Array.from(panel.querySelectorAll('details'));
        questions.forEach((question, index) => {
          question.open = active && index === 0;
        });
      });
    }

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => activate(button.dataset.fizoFaqCategory));
      button.addEventListener('keydown', (event) => {
        const currentIndex = categoryButtons.indexOf(button);
        let targetIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetIndex = (currentIndex + 1) % categoryButtons.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetIndex = (currentIndex - 1 + categoryButtons.length) % categoryButtons.length;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = categoryButtons.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        const target = categoryButtons[targetIndex];
        activate(target.dataset.fizoFaqCategory);
        target.focus();
      });
    });

    root.addEventListener('shopify:block:select', (event) => {
      const categoryKey = event.target.dataset.fizoFaqQuestionCategory;
      if (categoryKey) activate(categoryKey);
    });

    activate(categoryButtons[0].dataset.fizoFaqCategory);
  }

  scope.FizoFaq = { initialize };

  if (typeof document !== 'undefined') {
    const initializeAll = (container) => {
      const roots = container.matches?.('[data-fizo-faq]')
        ? [container]
        : Array.from(container.querySelectorAll('[data-fizo-faq]'));
      roots.forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document));
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  }
})(globalThis);
